import { getField, toNumber, toPortString } from './pcapCsvFields';

export const buildPcapConversationsFromRows = (rows) => {
  try {
    const arr = Array.isArray(rows) ? rows : [];

    return arr
      .map((row) => {
        const from = getField(row, ['Client Addr', 'src', 'Src', 'source', 'Source']);
        const to = getField(row, ['Server Addr', 'dst', 'Dst', 'target', 'Target']);
        const fromId = from != null ? String(from).trim() : '';
        const toId = to != null ? String(to).trim() : '';
        if (!fromId || !toId) return null;

        const fromPort = toPortString(getField(row, ['Client Port', 'client_port', 'ClientPort', 'src port', 'Src Port', 'src_port']));
        const toPort = toPortString(getField(row, ['Server Port', 'server_port', 'ServerPort', 'dst port', 'Dst Port', 'dst_port']));
        const fromMac = getField(row, ['Client MAC', 'client_mac', 'ClientMac', 'src mac', 'Src MAC', 'src_mac']);
        const toMac = getField(row, ['Server MAC', 'server_mac', 'ServerMac', 'dst mac', 'Dst MAC', 'dst_mac']);
        const clientBytes = toNumber(getField(row, ['Client Bytes', 'tx bytes', 'tx_bytes', 'Tx Bytes', 'TX Bytes', 'tx']));
        const serverBytes = toNumber(getField(row, ['Server Bytes', 'rx bytes', 'rx_bytes', 'Rx Bytes', 'RX Bytes', 'rx']));
        const packets = Math.floor(toNumber(getField(row, ['Packets', 'packets'])));
        const protocol = getField(row, ['Protocol', 'protocol']) || '';

        return {
          from: fromId,
          to: toId,
          fromPort,
          toPort,
          fromMac: fromMac != null ? String(fromMac).trim() : '-',
          toMac: toMac != null ? String(toMac).trim() : '-',
          bytesTx: clientBytes,
          bytesRx: serverBytes,
          bytesTotal: clientBytes + serverBytes,
          packets,
          protocol: protocol != null ? String(protocol).trim() : '',
        };
      })
      .filter(Boolean);
  } catch (e) {
    return [];
  }
};
